import {DateRange} from '@angular/material/datepicker';

export class CustomDateRangeChangeEventModel {
  constructor(id: string, dateRange: DateRange<Date>) {
    this._id = id;
    this._dateRange = dateRange;
  }

  private _id: string;

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  private _dateRange: DateRange<Date>;

  get dateRange(): DateRange<Date> {
    return this._dateRange;
  }

  set dateRange(value: DateRange<Date>) {
    this._dateRange = value;
  }
}
